import styled from 'styled-components';

import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { RoundedBlock } from '@r1-frontend/ui-react/experimental/blocks';

export const BottomStickyOrderSummaryWrapper = styled.div`
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    row-gap: 24px;
`;

export const OrderSummaryWrapper = styled(RoundedBlock)`
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    padding: 24px;
`;

export const StyledDefaultPopup = styled(DefaultPopup)`
    & > div {
      top: 24px;
      right: 24px;
    }
`;
